import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const termsConditionsService = {
    getAllAssessmentTermsConditions,
    getAssessmentTermsConditionsForLanguage,
    createAssessmentTermsConditions,
    updateAssessmentTermsConditions
};

async function getAllAssessmentTermsConditions() {
  const localKey = "assessmentTermsConditions";
  const cached = localStorage.getItem(localKey);
  if (cached) {
    try {
      return JSON.parse(cached); 
    } catch (err) {
      console.warn("Failed to parse cached terms & conditions:", err);
      localStorage.removeItem(localKey); 
    }
  }

  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/assessment/terms-and-conditions/getAll/`,
    requestOptions
  );

  const data = await APIHandler.handleResponse(response);
  localStorage.setItem(localKey, JSON.stringify(data));

  return data;
}

async function getAssessmentTermsConditionsForLanguage(language_id) {
  const requestOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    }
  };

  const response = await fetch(
    `${config.oat_api_url}/assessment/terms-and-conditions/get/${language_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function createAssessmentTermsConditions(obj) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj),    
  };

  const response = await fetch(
    `${config.oat_api_url}/assessment/terms-and-conditions/add/`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}

async function updateAssessmentTermsConditions(obj) {
  const requestOptions = {
    method: "PUT",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(obj),    
  };

  const response = await fetch(
    `${config.oat_api_url}/assessment/terms-and-conditions/update/${obj.term_condition_id}`,
    requestOptions
  );
  return APIHandler.handleResponse(response);
}


